export default __webpack_public_path__ + "static/media/clock.79fbef48.svg";